export enum TelcoSubTypeEnum {
    internet = 'internet',
    landline = 'landline',
    fourGHome = 'fourGHome',
    homelive = 'homelive',
    airbox = 'airbox',
    mobile = 'mobile',
    open = 'open',
    parnasse = 'parnasse',
    generic = 'generic',
}
